export const TAG_TYPE = 'i_feel_lucky';
